import { useEffect, useState } from "react";
import axios from "axios";
import { apiUrl } from "@/lib/media";

let cache = null;
let pending = null;

const load = () => {
  if (!pending) {
    pending = axios.get(apiUrl("/photos"))
      .then((r) => {
        cache = {
          themes: Array.isArray(r.data?.themes) ? r.data.themes.filter((t) => t?.cover?.file) : [],
          photos: Array.isArray(r.data?.photos) ? r.data.photos : [],
        };
        return cache;
      })
      .catch(() => { pending = null; return null; });
  }
  return pending;
};

export const usePhotos = () => {
  const [data, setData] = useState(cache || { themes: [], photos: [], loading: true });
  useEffect(() => {
    let alive = true;
    if (!cache) load().then((d) => { if (alive) setData(d || { themes: [], photos: [] }); });
    return () => { alive = false; };
  }, []);
  return data;
};
